!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define(["react", "prop-types"], e) : "object" == typeof exports ? exports.Pace = e(require("react"), require("prop-types")) : t.Pace = e(t.react, t["prop-types"]);
}(window, function (n, r) {
  return function (n) {
    var r = {};

    function o(t) {
      if (r[t]) return r[t].exports;
      var e = r[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return n[t].call(e.exports, e, e.exports, o), e.l = !0, e.exports;
    }

    return o.m = n, o.c = r, o.d = function (t, e, n) {
      o.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, o.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, o.t = function (e, t) {
      if (1 & t && (e = o(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (o.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        o.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, o.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return o.d(e, "a", e), e;
    }, o.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, o.p = "/", o(o.s = 0);
  }([function (t, e, n) {
    t.exports = n(1);
  }, function (t, e, n) {
    "use strict";

    n.r(e);
    var o = n(2),
        i = n.n(o),
        r = n(3),
        u = n.n(r);

    function c(t) {
      return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function f() {
      return (f = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    function l(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
      }
    }

    function p(t) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
    }

    function s(t, e) {
      return (s = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      })(t, e);
    }

    function y(t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    }

    function b(t, e, n) {
      return e in t ? Object.defineProperty(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    }

    var a = function (t) {
      function a() {
        var t, e, n, r;
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, a);

        for (var o = arguments.length, i = new Array(o), u = 0; u < o; u++) {
          i[u] = arguments[u];
        }

        return n = this, r = (t = p(a)).call.apply(t, [this].concat(i)), b(y(y(e = !r || "object" !== c(r) && "function" != typeof r ? y(n) : r)), "state", {
          width: 0
        }), b(y(y(e)), "getStyles", function () {
          var t = {
            main: {
              height: e.props.height || 10,
              backgroundColor: e.props.color || "#2c3e50",
              transition: "width 0.5s",
              width: Math.floor(100 * e.state.width) + "%"
            },
            container: {
              position: "absolute",
              width: "100%"
            }
          };
          return e.props.style && (t.main = Object.assign({}, e.props.style, t.main)), t;
        }), e;
      }

      var e, n, r;
      return function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
          constructor: {
            value: t,
            writable: !0,
            configurable: !0
          }
        }), e && s(t, e);
      }(a, o["Component"]), e = a, (n = [{
        key: "componentDidMount",
        value: function value() {
          var t = this;
          this.intervalId = setInterval(function () {
            t.setState({
              width: t.state.width + .25 * (1 - t.state.width)
            });
          }, 500 + 200 * Math.random());
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          clearInterval(this.intervalId);
        }
      }, {
        key: "render",
        value: function value() {
          var t = this.getStyles(),
              e = this.props,
              n = e.id,
              r = e.className;
          return i.a.createElement("div", {
            style: t.container
          }, i.a.createElement("div", f({
            id: n,
            className: r
          }, {
            style: t.main
          })));
        }
      }]) && l(e.prototype, n), r && l(e, r), a;
    }();

    b(a, "propTypes", {
      height: u.a.number,
      color: u.a.string,
      style: u.a.object,
      id: u.a.string,
      className: u.a.string
    }), e.default = a;
  }, function (t, e) {
    t.exports = n;
  }, function (t, e) {
    t.exports = r;
  }]).default;
});